import React, { useState, useEffect, useRef, useContext } from 'react'
import { request, message as mes } from 'meinian-package/src/utils'
import { Affix, message } from 'antd'
import qs from 'qs'
import { useParams } from 'react-router-dom'
import { Empty, Loading } from 'meinian-package/src/baseComponent'
import Button from 'meinian-package/src/baseComponent/button'
import { teamHasAuth } from 'meinian-package/src/utils/auth'
import util from 'meinian-package/src/utils/util'
import PermissionsPage from 'view/components/permissionsPage'
import ModalConfirm from 'meinian-package/src/component/modal/modalConfirm'
import globalData from 'meinian-package/src/common/globalData'
import useVersionNumber from 'meinian-package/src/common/hooks/useVersionNumber'
import emitter, { EmitterEvents } from 'meinian-package/src/utils/emitter'
import { RANK_DEFAULT_VALUE } from 'component/filter/rank'
import FirstTooltip, { FIRST_TOOLTIP_TYPE } from 'meinian-package/src/component/firstTooltip'
import isIPad from 'meinian-package/src/common/isIPad'
import { IDEA_MASS_ROLE } from 'meinian-package/src/component/enum'

import { useDeepCompareEffect } from 'ahooks'
import CooperationTipModal from './cooperationTipModal'
import Analysis from './analysis'
import List from './list'
import InfoWrap from './infoWrap'
import useStyleFilterQueryParams from '../../components/styleFilter/useStyleFilterQueryParams'
import {
  StyleSwitchingView,
  UploadStyle,
  STYLE_RULES_KEY,
  STYLE_TYPE_KEY,
  STYLE_RULES_VALUE,
} from '../../components/fixedOperation'
import { TAB, VIEW_MODE, EmitterEvents as CurEmitterEvents, TIP_KEYS } from './enum'
import MoreInspiration from './list/moreInspiration'
import { InspirationProvider } from './inspirationTree.context'
import { useBatch } from '../../components/batch'
import BatchOperation from '../../components/batch/batchOperation'
import Header from './header'
import { AccountContext } from '../../../context'
import GuideModal from '../../components/guideModal'

import './index.less'

export default () => {
  const routerParams = useParams()
  return <DetailInspiration key={routerParams.id} />
}

const DetailInspiration = () => {
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })
  const queryParams = useStyleFilterQueryParams()
  const defaultParams = {
    dontShowSubInspiration: 0,
    ...RANK_DEFAULT_VALUE,
  }
  const { teamInfo = {} } = useContext(AccountContext)
  const [info, setInfo] = useState({})
  const [loading, setLoading] = useState(true)
  const [isExist, setIsExist] = useState(true)
  const [hasAuth, setHasAuth] = useState(true)
  const [params, setParams] = useState({
    containSubFolder: null,
    markTimes: null,
    ...queryParams,
    ...defaultParams,
  })
  const [tab, setTab] = useState(query.tab || TAB.ALL)
  const [columnRulesType, setColumnRulesType] = useState(STYLE_RULES_VALUE)
  const [viewMode, setViewMode] = useState(VIEW_MODE.TEXT)
  const $masonry = useRef()
  const { batchValue, setBatchValue, batchAll, setBatchAll, cancelBatch } = useBatch()
  const { authMeal, isAuthVersion } = useVersionNumber()
  const [freezeMesVisible, setFreezeMesVisible] = useState(false)
  const $title = useRef(null)

  const isFreezeFun = (status) => {
    if (status === 0 && isAuthVersion(150001)) {
      return true
    }
    return false
  }

  useEffect(() => {
    if (isFreezeFun(info.freezeStatus)) {
      setFreezeMesVisible(true)
    }
  }, [info, authMeal])

  const [tabMoveInspirationParams, setTabMoveInspirationParams] = useState({
    cardType: null,
  })
  const [hasFilter, setHasFilter] = useState(false)
  const [styleFilterCount, setStyleFilterCount] = useState(0)

  useEffect(() => {
    if (/Mobi|Android|iPhone/i.test(navigator.userAgent) && query.shareUrl && !isIPad) {
      // 当前设备是移动设备
      window.location.href = `/visitor/insColl/detail/h5?shareUrl=${query.shareUrl}`
    }
    globalData.get(STYLE_RULES_KEY, setColumnRulesType, STYLE_RULES_VALUE)
    globalData.get(STYLE_TYPE_KEY, setViewMode, VIEW_MODE.TEXT)
    globalData.get(
      'mn:inspirationParams:dontShowSubInspiration',
      (val) => {
        setParams((pre) => ({ ...pre, dontShowSubInspiration: +val }))
      },
      0
    )
    const subUploadImage = () => {
      $masonry.current?.init()
    }
    mes.sub('onMNUploadImage', subUploadImage)
    fetchInfo()
    const subFetchInfo = () => {
      fetchInfo()
    }
    emitter.on(EmitterEvents.fastAccess, subFetchInfo)
    return () => {
      emitter.off(EmitterEvents.fastAccess, subFetchInfo)
      mes.remove('onMNUploadImage', subUploadImage)
    }
  }, [])

  useEffect(() => {
    document.title = info.name || '美念'
    return () => {
      document.title = '美念'
    }
  }, [info])

  useDeepCompareEffect(() => {
    if (!query.shareUrl && info?.id === Number(query?.inspirationId)) {
      util.track('mn-inspiration-detail-page', {
        module1: query?.trackSourceType || '其他',
        inspirationId: info?.id,
      })
    }
  }, [info?.id])

  const fetchInfo = async (isChid) => {
    setLoading(true)
    try {
      let _info = {}
      if (query.shareUrl) {
        _info = await request.get('/zhikuan/ins/inspiration/get-share-inspiration-info', {
          ignoreError: true,
          params: { shareUrl: query.shareUrl, inspirationId: query.inspirationId },
        })
        util.track('mn-inspiration-detail-page', {
          module1: query?.trackSourceType || '其他',
          inspirationId: _info?.id,
        })
      } else {
        _info = await request.get('/zhikuan/ins/inspiration/get-inspiration-info', {
          ignoreError: true,
          params: { inspirationId: query.inspirationId },
        })
      }
      setInfo(_info)
    } catch (error) {
      message.error(error.errorDesc)
      const curTimeId = setTimeout(() => {
        clearInterval(curTimeId)
        if (error.errorCode === 'INS0008') {
          if (!query.shareUrl) {
            window.location.href = '/meinian/home/coll'
          } else {
            setIsExist(false)
          }
        }
        if (error.errorCode === 'INS0047') {
          if (!query.shareUrl) {
            window.location.href = '/meinian/home/coll'
          } else {
            setHasAuth(false)
          }
        }
        if (error.errorCode === 'INS0036' && !isChid) {
          if (!query.shareUrl) {
            window.location.href = '/meinian/home/coll'
          } else {
            setHasAuth(false)
          }
        }
        if (error.errorCode === 'INS0036' && isChid) {
          if (!query.shareUrl) {
            window.location.href = `/meinian/home/coll/detail/${info.parentId}?inspirationId=${info.parentId}`
          } else {
            setHasAuth(false)
          }
        }
      }, 300)
    }
    setLoading(false)
  }

  const onTabChange = (_tab) => {
    setTab(_tab)
    cancelBatch()
  }

  const auth = info.loginUserInfo?.inspirationPermissions || []
  const [guides, setGuides] = useState({})
  const guideKey = 'mn-home-inspiration-guides'

  const fetchDataKeys = async () => {
    const _guides = await globalData.toGetObj(guideKey)
    if (!_guides) {
      const _values = {}
      TIP_KEYS.forEach((item, i) => {
        if (i === 0) {
          _values[item] = 1
        } else {
          _values[item] = 0
        }
      })
      setGuides(_values)
      return
    }
    setGuides(_guides)
  }

  useEffect(() => {
    const onTipChange = (_key) => {
      TIP_KEYS.forEach((item) => {
        guides[item] = 0
      })
      const curIndex = TIP_KEYS.findIndex((tip) => tip === _key)
      guides[TIP_KEYS[curIndex + 1]] = 1
      setGuides({ ...guides })
      globalData.toSetObj(guideKey, guides)
    }
    fetchDataKeys()
    emitter.on(CurEmitterEvents.TIP_KEYS, onTipChange)
    return () => {
      emitter.off(CurEmitterEvents.TIP_KEYS, onTipChange)
    }
  }, [])

  useEffect(() => {
    if (!batchValue) {
      cancelBatch()
    }
  }, [batchValue])

  if (!isExist) return <Empty title="抱歉，该灵感集已被删除" />
  if (!hasAuth) return <Empty title="抱歉，您暂无查看权限" />

  return (
    <InspirationProvider>
      <GuideModal
        visible={guides[TIP_KEYS[5]]}
        title="如何高效查看并整理款式？"
        content="美念提供了多种视图模式查看款式、快速管理款式（移动/删除）等功能，详细了解请点击"
        onClose={() => {
          emitter.emit(CurEmitterEvents.TIP_KEYS, TIP_KEYS[5])
        }}
        onJumpUrl={() => {
          util.track('mn_newuser_click', {
            module1: '板块引导',
            module2: '灵感集详情引导',
          })
          window.open('/meinian/document')
        }}
      />
      <FirstTooltip
        visible={guides[TIP_KEYS[2]]}
        contentWidth={204}
        text="点此上传款式至灵感集，开启高效管理灵感之路～"
        placement="left"
        onClose={() => {
          emitter.emit(CurEmitterEvents.TIP_KEYS, TIP_KEYS[2])
        }}
        type={FIRST_TOOLTIP_TYPE.LEFT}
      >
        <UploadStyle
          style={{ right: 16, bottom: 158 }}
          onClick={() => {
            setBatchValue(null)
            if (guides[TIP_KEYS[2]]) {
              emitter.emit(CurEmitterEvents.TIP_KEYS, TIP_KEYS[2])
            }
          }}
          onChange={() => {
            $masonry.current?.init()
          }}
        />
      </FirstTooltip>
      {tab === TAB.ALL && (
        <StyleSwitchingView
          style={{ right: 16, bottom: 102 }}
          columnRulesType={columnRulesType}
          viewMode={viewMode}
          onColumnRulesType={(val) => {
            setColumnRulesType(val)
            $masonry.current?.init()
            globalData.set(STYLE_RULES_KEY, val)
          }}
          onViewMode={(val) => {
            setViewMode(val)
            globalData.set(STYLE_TYPE_KEY, val)
            $masonry.current?.init()
          }}
        />
      )}
      <Header auth={auth} />
      <Loading spinning={loading}>
        <div className="meinian-detail-coll">
          <InfoWrap
            guides={guides}
            cooperationTipHidden={guides[TIP_KEYS[1]]}
            onCooperationTipClose={() => {
              if (guides[TIP_KEYS[1]]) {
                emitter.emit(CurEmitterEvents.TIP_KEYS, TIP_KEYS[1])
              }
            }}
            tabValue={tab}
            info={info}
            auth={auth}
            onTabChange={onTabChange}
            isFreezeFun={isFreezeFun}
            //
            setBatchValue={setBatchValue}
            params={params}
            //
            teamInfo={teamInfo}
            fetchInfo={fetchInfo}
            total={$masonry.current?.total || 0}
            setInfo={setInfo}
            onInit={() => {
              fetchInfo()
              $masonry.current?.init()
            }}
            hasFilter={hasFilter}
            setHasFilter={setHasFilter}
            styleFilterCount={styleFilterCount}
            tabMoveInspirationParams={tabMoveInspirationParams}
            setTabMoveInspirationParams={setTabMoveInspirationParams}
            defaultParams={defaultParams}
            setParams={setParams}
            setStyleFilterCount={setStyleFilterCount}
          />
          {batchValue && (
            <Affix
              target={() => document.body}
              offsetTop={64}
              onChange={(affixed) => {
                $title.current.style.marginTop = affixed ? 0 : 64
              }}
            >
              <div className="meinian-detail-coll-operation" ref={$title}>
                <BatchOperation
                  batchValue={batchValue}
                  batchAll={batchAll}
                  $masonry={$masonry}
                  info={info}
                  params={params}
                  cancelBatch={cancelBatch}
                  auth={auth}
                />
              </div>
            </Affix>
          )}
          <div
            style={{
              display: tab != TAB.ALL && info.id && 'none',
              marginTop: '24px',
            }}
          >
            <List
              disabledIsEnd={tab != TAB.ALL}
              type={info.isPro}
              tab={tab}
              info={info}
              columnRulesType={columnRulesType}
              batchValue={batchValue}
              cancelBatch={cancelBatch}
              params={params}
              query={query}
              $masonry={$masonry}
              setBatchAll={setBatchAll}
              viewMode={viewMode}
              fetchInfo={fetchInfo}
            />
          </div>
          {!info.id
            ? null
            : tabListComponent(tab, info, {
              tabMoveInspirationParams,
            })
              && tabListComponent(tab, info, {
                tabMoveInspirationParams,
              })}
        </div>
      </Loading>
      {freezeMesVisible && (
        <ModalConfirm
          title="该灵感集已被冻结"
          content="仅支持查看、下载和导出内容，也可以重新开通专业版后使用"
          visible={freezeMesVisible}
          footer={
            <>
              <Button
                style={{ marginLeft: 8 }}
                onClick={() => {
                  window.open('/meinian/home/version', '_self')
                }}
              >
                查看更多版本权益
              </Button>
              <Button
                type="primary"
                width={74}
                style={{ marginLeft: 8, height: '32px' }}
                onClick={() => setFreezeMesVisible(false)}
              >
                知道了
              </Button>
            </>
          }
        />
      )}
      {info?.loginUserInfo?.role === IDEA_MASS_ROLE.OWNER && (
        <CooperationTipModal
          visible={guides[TIP_KEYS[0]]}
          onClose={() => {
            if (guides[TIP_KEYS[0]]) {
              emitter.emit(CurEmitterEvents.TIP_KEYS, TIP_KEYS[0])
            }
          }}
          onGo={() => {
            if (guides[TIP_KEYS[1]]) {
              emitter.emit(CurEmitterEvents.TIP_KEYS, TIP_KEYS[1])
            }
          }}
        />
      )}
    </InspirationProvider>
  )
}

const tabListComponent = (tab, info, option) => {
  const { tabMoveInspirationParams } = option
  const TAB_COMPONENT = {
    [TAB.DATA_ANALYSIS]: <Analysis info={info} />,
    [TAB.OFFICIAL_INSPIRATION]: !teamHasAuth('meinian_blog_recommend') ? (
      <PermissionsPage type="intellectRecommend" style={{ marginLeft: 0, width: '100%' }} />
    ) : (
      <MoreInspiration info={info} tabMoveInspirationParams={tabMoveInspirationParams} />
    ),
  }
  return TAB_COMPONENT[tab]
}
